export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9139.364e2121.jpg";